import { useAuth } from "../context/AuthContext";
import { ROLES } from "../adminConfig";
import { verifyAdminAccess } from "../utils/verifyAdminAccess";

const usePermission = () => {
  const { user, permissions, isRefreshing } = useAuth();
  const role = user?.role || null;
  const isSuperAdmin = role === ROLES.SUPER_ADMIN;
  const can = (permission) => verifyAdminAccess(user, permission);

  return { can, isSuperAdmin, role, user, permissions, isRefreshing };
};

export default usePermission;
